/* eslint-disable */

import $ from 'jquery';
import '../lazyload/lazyload';
import 'slick-carousel';

var self = {
  init: function (elem, slickOptions) {
    elem.on('init reInit beforeChange afterChange', function () {
      self.fixLazyLoadXT(elem);
      elem.find('img[data-src]').lazyLoadXT();
    });
    elem.slick(slickOptions);
  },
  fixLazyLoadXT: function (elem) {
    // fix lazyLoadXT for images within cloned slides
    const clonedLazyImg = elem.find('.slick-cloned img[data-src]');
    clonedLazyImg.each(function () {
      $(this).removeAttr('src');
      $(this).removeClass('lazy-loaded lazy-hidden');
      this.outerHTML = this.outerHTML;
    });
  }
};

export default self;



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/slickslider/slickslider.js